<template>
  <div id="sugarControl">
    <div class="box1">
      <p class="title1">瞬感数据同步到糖糖圈APP</p>
      <p class="title1Text">医生可以通过手机直观的看到您的动态数据 ，进行准确的糖尿病病症分析治疗(糖糖圈APP3.7以上版本)</p>
      <p class="sugarTu1">
        
      </p>
    </div>
    <div class="container" v-if="showLogin">
      <el-row type="flex" justify="center">
        <!-- <el-col :span="8" >
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="密码登录" name="first">
              <p class="userP"><i class="userTu"></i><input style="-webkit-user-select:auto" ref="account" placeholder="请输入手机号" class="user" type="text"/></p>
              <p class="keyP"><i class="keyTu"></i><input style="-webkit-user-select:auto" ref="password" placeholder="请输入密码" class="key" type="password"/></p>
              <span slot="footer" class="dialog-footer">
                <el-button id="dl1" type="primary" @click="dlFunction">登录</el-button>
                <el-button id="hide-success-btn" type="primary" @click="scanlogin">扫码登录成功</el-button>
              </span>
            </el-tab-pane>
            <el-tab-pane label="扫码登录" name="second">
              <iframe src="https://www.ttq.so/html/qrcode_login.html" id="qr-code" title="请使用APP扫码"></iframe>
            </el-tab-pane>
          </el-tabs>
        </el-col> -->

        <el-col :span="10">
          <el-row type="flex" justify="center" class="padbot">
            <el-col :span="11.5" style="padding-right:32px" class="saoText" >
              <span @click="select(0)" :class="[!showQrCode ? 'nowSelect':'']" >扫码登录</span> 
            </el-col>
            <el-col :span="1" style="text-align:center;padding-right:32px">
              <div class="line"></div>
            </el-col>
            <el-col :span="11.5" class="saoText">
             <span  @click="select(1)" :class="[showQrCode ? 'nowSelect':'']">密码登录</span> 
            </el-col>
          </el-row>
          
          <div v-show="!showQrCode">
            <el-row type="flex" justify="center">
              <el-col :span="12">
                <iframe :src="srcUrl" id="qr-code" title="请使用APP扫码" style="height:250px;width:250px"></iframe>
                <!-- <iframe src="http://test.ttq.so/html/qrcode_login.html" id="qr-code" title="请使用APP扫码" style="height:250px;width:250px"></iframe> -->
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col  class="openTtq">
                <span class="openTtqText">打开糖糖圈app扫描二维码，上传瞬感txt文件</span>
                <span class="openA"><a href="javascript:void(0);" @click="tiaozhuan()" style="color:#10c7dc">不知道如何从瞬感扫描仪导出文件？</a></span>
              </el-col>
            </el-row>
            <el-button id="hide-success-btn" type="primary" @click="scanlogin" style="display:none">扫码登录成功</el-button>
          </div>
           
          <div v-show="showQrCode">
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <p class="userP">
                  <i class="userTu"></i>
                  <input style="-webkit-user-select:auto" ref="account" placeholder="请输入手机号" class="user" type="text"/>
                </p>
                <p class="keyP">
                  <i class="keyTu"></i>
                  <input style="-webkit-user-select:auto" ref="password" placeholder="请输入密码" class="key" type="password"/>
                </p>  
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col class="textCenter">
                <el-button id="dl1" type="primary" @click="dlFunction">登录</el-button>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col class="inputText">
                <span class="openTtqText">登录糖糖圈，上传瞬感txt文件</span>
                <span class="openA"><a href="javascript:void(0);" @click="tiaozhuan()" style="color:#10c7dc">不知道如何从瞬感扫描仪导出文件？</a></span>
              </el-col>
            </el-row>
          </div>
          
        </el-col>
      </el-row> 
    </div>
    <div class="container pT155" v-if="!showLogin">
      <el-row class="pb20" type="flex" justify="center">
        <el-col :span="6"></el-col>
        <el-col :span="7" class="selectBox"> 
          <i class="tu4 selectBox_i" @click="tbText"></i>
          <input type="file" name="avatar" style="display:none" @change="changeImage($event)" ref="avatarInput">
          <p class="selectBox_p">选择瞬感TXT文件，<span class="selectBox_p_a">继续上传</span> </p>
        </el-col>
        <el-col :span="9">
          <p class="hello">{{nickName}},您好</p>
          <p class="upTextSize">您已成功上传<span class="upTextSize_span">{{frequency}}</span>次</p>
          <p class="upDate">最近一次成功上传日期：{{time}}</p>
          <p class="findLine">您可在糖糖圈APP血糖日历中查看动态曲线</p>
        </el-col>
        <el-col :span="2"></el-col>
      </el-row>
      <el-row class="padTop" type="flex" justify="center">
        <span class="findText"><a href="javascript:void(0);" @click="tiaozhuan()" style="color:#10c7dc">不知道如何从瞬感扫描仪导出文件?</a></span>
      </el-row>
      
    </div>
    
    <footerBottomer></footerBottomer>

    <!-- <div style="border-top:1px solid #d4d4d4" class="box1">
      <div class="boxEnd-1">
        <i class="logo1"></i>
        <p>400热线：400-836-5596<br/>客服电话：0755-27299992<br/>渠道合作：caoqifan@ttq.so<br/>官方微信：ttqcare<br/>地址：广东省深圳市宝安区西乡街道宝民二路IDT研发中心4层</p>
      </div>
      <div class="boxEnd-2">
        <span class="ewm1"><label class="wxb">官方微博</label></span>
        <span class="ewm2"><label class="wxb">官方微信</label></span>
        <i class="xian"></i>
        <span class="yptu">
          <label class="ypwz">雅培辅理善瞬感软件</label>
          <a class="mac" href="https://freestyleserver.com/distribution/fxaa20.aspx?product=fslibre&version=latest&os=mac&region=cn&language=xx_yy"></a>
          <a class="win" href="https://freestyleserver.com/distribution/fxaa20.aspx?product=fslibre&version=latest&os=win&region=cn&language=xx_yy"></a>
        </span>
      </div>
    </div>
    <div style="background: #f7f8fa">
      <div class="box-ends">
        Copyright @ 2014-2024 aibaowei.All Rights Reserved
        <label>爱宝惟生物科技有限公司版权所有</label>
        <a href="http://www.beian.miit.gov.cn">粤ICP备14072944号</a>
      </div>
    </div> -->
  </div>
</template>

<script>
  import footerBottomer from './footerBottomer.vue'
  let text;
  export default {
    name: 'sugarControl',
    components: {
     footerBottomer
  	},
    data () {
      return {
        nickName:"",
        srcUrl:"",
      	host: this.GLOBAL.host,
        hostAuto:this.GLOBAL.hostAuto,
        avatar: '',
        centerDialogVisible: true,
        texts:3,
        showQrCode:false,
        showLogin:true,
        frequency:"",
        time:""
      }
    },
    methods: {
      getUrl(){
        this.srcUrl = this.hostAuto + '/html/qrcode_login.html'
      },
      tiaozhuan(){
        window.open(this.host + "/info.html")
      },
      getUpInfo(){
        this.$http.get(this.hostAuto + '/site/getUploadHistory.html').then((response) => {
            if(response.data.retCode == 1){
              let data = response.data.data;
              this.frequency = data.upload_count
              this.time = data.last_upload_time
              this.nickName = data.member_info.nickname
            }
        })
      },
      select(n){
        console.log(n)
        if(n==0){
          this.showQrCode = false
        }else{
          this.showQrCode = true
        }
      },
      open2(msg) {
        this.$message({
          message: msg,
          type: 'success'
        });
      },
      open4(msg) {
        this.$message.error(msg);
      },
      edit() {
        // 上传文件
        if (this.$refs.avatarInput.files.length !== 0) {
          text = new FormData()
          let _this=this
          text.append('avatar', this.$refs.avatarInput.files[0]);
          console.log(text)
          this.$axios.post('/site/uploadFile.html', text, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(function (response) {
              _this.open2(response.data.msg);
            if(response.data.msg=="您未登陆"){
              _this.centerDialogVisible=true
              _this.texts=0
            }
            if(response.data.retCode==1){
              _this.texts=1
              _this.getUpInfo()
              console.log(_this.texts);
            }
            }).catch(function (response) {

            });
        }
      },
      scanlogin(){
          this.centerDialogVisible=false;
          this.showLogin = false;
          this.getUpInfo();
          this.$message({
            message: "扫码登录成功！",
            type: 'success'
          });
      },
      dlFunction(){
        let _this=this;
        this.$http.get('/site/login.html?account='+this.$refs.account.value+'&password='+this.$refs.password.value+'').then((response) => {
          _this.open2(response.data.msg);
          if(response.data.retCode==0){
            this.centerDialogVisible=true
            this.showLogin = true
            return false
          }else{
            this.centerDialogVisible=false
            this.showLogin = false
            this.getUpInfo()
            console.log(this.texts)
            if(this.texts==0){
              _this.edit()
            }
          }
        }, (response) => {
          _this.open4(response.data.msg);
        });

      },
      tbText(){
        this.$refs.avatarInput.click()
      },
      changeImage(e) {
        var file = e.target.files[0]
        var reader = new FileReader()
        if(file.size>5242880){
          this.open4('上传文件超过限制（5M）大小');
          return false
        }else if(file.type!='text/plain'){
          this.open4('上传文件格式错误');
          return false
        }else{
          this.open1();
        }
        var that = this
        reader.readAsDataURL(file)
        reader.onload = function(e) {
          that.avatar = this.result
        }
      },
      open1() {
        this.$confirm('确认上传文件', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.edit();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消上传'
          });
        });
      }
    },
    mounted(){
      this.getUrl()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .qr-code-area{
     text-align:center;
  }
</style>
<style scoped>
  input::-webkit-input-placeholder {font-size: 16px;}
  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ font-size:16px;} 
  input::-moz-placeholder { /* Mozilla Firefox 19+ */font-size:16px;} 
  input:-ms-input-placeholder { /* Internet Explorer 10+ */ font-size:16px;} 
  .pT155{padding-top:155px;}
  .padTop{padding-top:52px} 
  .findText{font-size:19px;color:#10c7dc;}
  .upDate{font-size:19px;padding-top:12px;color:#757575} 
  .findLine{font-size:19px;color:#757575;padding-top:12px;padding-bottom:10px}
  .upTextSize{font-size:22px;color:#666}
  .upTextSize_span{color:#10c7dc;display:inline}
  .selectBox_p{font-size:19px;position:absolute;top:171px;color:#666;left:10px;}
  .hello{font-size:26px;padding-bottom:30px;color:#10c7dc;}
  .selectBox_p_a{color:#f62119;display:inline;}
  .selectBox_i{position:absolute;top:-55px;left:36px;}
  .selectBox{text-align:center;position:relative}
  .pb20{padding-bottom:20px}
  .inputText{text-align:center;padding-top:10px}
  .textCenter{text-align:center}
  .padbot{padding-bottom:26px}
  .openTtq{text-align:center;padding-top:14px}
  .openTtqText{font-size:21px;margin-bottom:11px;color: #b2b2b2}
  .openA{font-size:19px;margin-bottom:45px;}
  .padbot .line{width:1px;height:80%;background-color:#d2d2d2;margin-top:3px}
  .saoText{cursor:default;font-size:21px;font-weight:400;color: #666;text-align:center}
  .nowSelect{color:#10c7dc}
  .container{width:1200px;margin:0 auto;padding:44px 0}
  #hide-success-btn{display:none;}
  #sugarControl{margin-top: 90px}
  .box1{width: 1200px;margin: 0 auto;text-align: center;padding:50px;}
  .title1{font-size: 34px;color: #666;height:40px;line-height:40px}
  .title1Text{font-size: 19px;color: #bbb; height:30px;line-height:30px;margin-top:28px;}
  .sugarTu1{background: url("../../site/7-1(1).png") no-repeat center;height: 306px;margin-top: 104px }
  .sugarZy>*{vertical-align: middle}
  .tu1{width: 131px;height: 131px;background: url("../../site/7-2.png")}
  .tu2{width: 131px;height: 131px;background: url("../../site/7-3.png")}
  .tu3{width: 131px;height: 131px;background: url("../../site/7-4.png")}
  .tu4{width: 193px;height: 193px;background: url("../../site/upload.png") no-repeat top center;cursor:pointer;background-color:#f4fcfd;border-radius:50%;}
  .tuJt{width: 140px;height: 8px;background: url("../../site/jt.png")}
  .zyText{font-size: 12px;color: #666;width: 130px;position: relative;top:130px;text-align:center;cursor:pointer;}
  .sugarTitle{color: #00b9cd;font-size: 30px;text-align: left;margin-bottom: 20px}
  .text1{font-size: 16px;color: #666;text-align: left;text-indent: 4em;margin-bottom: 20px;line-height: 40px}
  .text1 a{color: #00b9cd;text-indent: 0em}
  .text2{font-size: 20px;text-align: left;text-indent: 3em}
  .text1Tu{width: 100%;height: 149px;background: url("../../site/7-7.png") no-repeat 20% center;}
  .sugarTu2{width: 85px;height: 93px;background: url("../../site/7-8.png");margin-left: 4em}
  .sugarTu3{width: 255px;height: 255px;background: url("../../site/7-9.png");margin-left: 4em}
  .sugarTu4{width: 586px;height: 417px;background: url("../../site/7-10.png");margin-left: 4em}
  .sugarTu5{width: 586px;height: 417px;background: url("../../site/7-11.png");margin-left: 4em}
  .sugarTu6{width: 586px;height: 417px;background: url("../../site/7-12.png");margin-left: 4em}
  .sugarTu7{width: 586px;height: 417px;background: url("../../site/7-13.png");margin-left: 4em}
  .sugarTu8{width: 806px;height: 982px;background: url("../../site/7-14.png");margin-left: 4em}
  .sugarTu9{width: 809px;height: 478px;background: url("../../site/7-15.png");margin-left: 4em}
  .sugarTu10{width: 811px;height: 553px;background: url("../../site/7-16.png");margin-left: 4em}
  .sugarTu11{width: 104px;height: 104px;background: url("../../site/7-17.png");margin-left: 4em}
  .sugarTu12{width: 80px;height: 80px;background: url("../../site/7-4.png"); background-size:100% 100%;vertical-align: middle}
  .sugarTu13{width: 941px;height: 376px;background: url("../../site/7-18.png");margin-left: 3em;margin-top: 30px}
  #dl1{width: 344px;height: 50px;background: #2dd6e9;border: 1px solid #2dd6e9;font-size: 20px;letter-spacing: 10px;}
  .el-dialog__title{color: #2dd6e9;font-size: 22px}
  .userP{height: 52px;width: 344px;margin:6px auto 26px auto;position: relative}
  .userTu{height: 20px;width:20px;background: url("../../site/User.png");position: absolute;left: 15px;top: 15px}
  .user{height: 50px;border: solid 1px #c3c3c3;border-radius: 5px;width: 100%;text-indent: 50px}
  .keyP{height: 52px;width: 344px;margin:0 auto 39px auto;position: relative}
  .keyTu{height: 20px;width:20px;background: url("../../site/Key.png");position: absolute;left: 15px;top: 15px}
  .key{height: 50px;border: solid 1px #c3c3c3;border-radius: 5px;width: 100%;text-indent: 50px}
  .scan_login{position: absolute;top: 24px;left: 20px;width: 30px;cursor: pointer; -webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;}

</style>



// WEBPACK FOOTER //
// sugarControl.vue?97b9acc2